import {date_newDate_fd} from "../S_Date";

window.dataLayer = window.dataLayer || [];
function gtag() {dataLayer.push(arguments);}

export const googleAnalytics_init = () => {

    gtag('js', date_newDate_fd());
    gtag('config', 'UA-134188739-1');
}

export const googleAnalytics_setUserId = (userData_c) => {

    if(userData_c != null){
        // gtag('set', {'user_id': userData_c.ud_userId_uid}); // Set the user ID using signed-in user_id.
        gtag('config', 'UA-134188739-1', {'user_id': userData_c.ud_userId_uid});
    }
}

